import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFacebook from '@fortawesome/fontawesome-free-brands/faFacebook';
import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter';
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram';
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';

import './footer.scss';

const Footer = () => (
  <footer>
    <div className="footer-content">
      <a aria-label="Send us an Email" href="mailto:hello@hackthenorth.com"><FontAwesomeIcon icon={faEnvelope} size="lg" /></a>
      <a aria-label="Find us on Facebook" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/hackthenorth/"><FontAwesomeIcon icon={faFacebook} size="lg" /></a>
      <a aria-label="Find us on Twitter" target="_blank" rel="noopener noreferrer" href="https://twitter.com/hackthenorth"><FontAwesomeIcon icon={faTwitter} size="lg" /></a>
      <a aria-label="Find us on Instagram" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/hackthenorth/"><FontAwesomeIcon icon={faInstagram} size="lg" /></a>
      <div className="spacer" />
      <a rel="noopener noreferrer" href="/code-of-conduct"><h3>CODE OF CONDUCT</h3></a>
      <a rel="noopener noreferrer" href="/privacy"><h3>PRIVACY POLICY</h3></a>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx